var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { forkJoin } from 'rxjs/observable/forkJoin';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { timer } from 'rxjs/observable/timer';
import { ActivatedRoute } from '@angular/router';
var DepositorInfoComponent = /** @class */ (function () {
    function DepositorInfoComponent(util, api, activatedRoute) {
        this.util = util;
        this.api = api;
        this.activatedRoute = activatedRoute;
        this.contactId = "";
        this.dpa_idcard = "";
        this.telephone1 = "";
        this.verifyOtp = "";
        this.contactType = "";
        this.ag = {};
        this.detail = {};
        this.status = {};
        this.isCrisis = true;
        this.contactDros = {};
        this.contact = {};
        this.crm03 = {};
        this.crm04 = {};
        this.crm05 = {};
        this.crm06 = {};
        this.bankName = "";
        this.disableResentOtp = false;
        this.totolWaitResend = 59;
        this.telephoneOtp = "";
        this.otp = "";
        this.otpRef = "";
        this.requestOtpLbl = "ส่ง";
        this.otpTimer = "";
        this.ElapseTime = 0;
        this.TotalTime = 0;
        this.OTPCountDown = "";
    }
    DepositorInfoComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var config, crisisConfig;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        $('*[data-toggle="collapse"]').on("click", function () {
                            if ($(this).hasClass("collapsed")) {
                                var iconBtn = $(this).find(".fa-chevron-circle-down")[0];
                                $(iconBtn).removeClass("fa-chevron-circle-down").addClass("fa-chevron-circle-up");
                            }
                            else {
                                var iconBtn = $(this).find(".fa-chevron-circle-up")[0];
                                $(iconBtn).removeClass("fa-chevron-circle-up").addClass("fa-chevron-circle-down");
                            }
                        });
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"));
                        return [4 /*yield*/, this.api.get("master", "configuration")];
                    case 1:
                        config = _a.sent();
                        crisisConfig = config.filter(function (c) {
                            return c.dpa_name == "CRISIS FLAG";
                        });
                        if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag == true) {
                            this.cookieData.isCrisis = true;
                            localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData));
                        }
                        else {
                            this.cookieData.isCrisis = false;
                            localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData));
                        }
                        this.isCrisis = this.cookieData.isCrisis;
                        return [2 /*return*/];
                }
            });
        });
    };
    DepositorInfoComponent.prototype.init = function (contact) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        //this.contact = contact;
                        //this.contactId = contact.contactid;
                        this.contactId = this.activatedRoute.snapshot.paramMap.get('id');
                        _a = this;
                        return [4 /*yield*/, this.getContact()];
                    case 1:
                        _a.contact = _b.sent();
                        // this.dpa_idcard = contact.dpa_idcard
                        // this.telephone1 = contact.telephone1
                        //this.contact.fullname = (contact.firstname == null ? "" : contact.firstname) + " " + (contact.lastname == null ? "" : contact.lastname)
                        this.dpa_idcard = this.contact.dpa_idcard;
                        this.telephone1 = this.contact.telephone1;
                        this.contact.fullname = (this.contact.firstname == null ? "" : this.contact.firstname) + " " + (this.contact.lastname == null ? "" : this.contact.lastname);
                        if (!this.isCrisis) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getDROS()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    DepositorInfoComponent.prototype.callApi = function () {
        return forkJoin([
            this.getDROS()
        ]);
    };
    DepositorInfoComponent.prototype.getContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "contactid=" + this.contactId;
                        return [4 /*yield*/, this.api.get("crmservice", "contact", para)];
                    case 1:
                        tmp = _a.sent();
                        return [2 /*return*/, tmp[0]];
                }
            });
        });
    };
    DepositorInfoComponent.prototype.getDROS = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var paraAgentBank, para, _a, _b, _c, _d, _e, bankName;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        paraAgentBank = "";
                        para = "CRM03=true&CRM04=true&CRM05=true&CRM06=true&CRM07=true";
                        if (this.contact.dpa_idcard != null && this.contact.dpa_idcard.trim().length > 0) {
                            para += "&dpa_id=" + this.contact.dpa_idcard;
                            paraAgentBank = "idcard=" + this.contact.dpa_idcard;
                        }
                        else if (this.contact.dpa_passport != null && this.contact.dpa_passport.trim().length > 0) {
                            para += "&dpa_id=" + this.contact.dpa_passport;
                            paraAgentBank = "idcard=" + this.contact.dpa_passport;
                        }
                        else if (this.contact.dpa_registrationid != null && this.contact.dpa_registrationid.trim().length > 0) {
                            para += "&dpa_id=" + this.contact.dpa_registrationid;
                            paraAgentBank = "idcard=" + this.contact.dpa_registrationid;
                        }
                        if (this.telephone1 != null && this.telephone1.trim().length > 0) {
                            para += "&telephoneno=" + this.telephone1;
                        }
                        //console.log(para);
                        _a = this;
                        return [4 /*yield*/, this.api.get("crmservice", "contactDros", para)];
                    case 1:
                        //console.log(para);
                        _a.contactDros = _f.sent();
                        _b = this;
                        return [4 /*yield*/, this.api.get("crmservice", "searchApprovalTicket", paraAgentBank)];
                    case 2:
                        _b.agenBankList = _f.sent();
                        _c = this;
                        return [4 /*yield*/, this.api.get("master", "personalType")];
                    case 3:
                        _c.masterDocNames = _f.sent();
                        _d = this;
                        return [4 /*yield*/, this.api.get("master", "companyType")];
                    case 4:
                        _d.masterDocNamesCompany = _f.sent();
                        _e = this;
                        return [4 /*yield*/, this.api.get("master", "bank")];
                    case 5:
                        _e.bankList = _f.sent();
                        if (this.contactDros.CRM07 != null && this.contactDros.CRM07.length > 0) {
                            if (this.bankList == null || this.bankList.length == 0) {
                                this.bankName = "ธนาคาร AAA";
                            }
                            else {
                                bankName = this.bankList.filter(function (mb) {
                                    return mb.dpa_bankcode == _this.contactDros.CRM07[0].BankCode;
                                });
                                if (bankName != null && bankName.length > 0) {
                                    this.bankName = bankName[0].dpa_name;
                                }
                                else {
                                    this.bankName = "ธนาคาร AAA";
                                }
                            }
                        }
                        else {
                            this.bankName = "ธนาคาร AAA";
                        }
                        this.drawTableStatus();
                        this.drawTableRefund();
                        this.drawTableDetail();
                        this.drawTableAgentBank();
                        return [2 /*return*/];
                }
            });
        });
    };
    DepositorInfoComponent.prototype.close = function () {
        window.close();
    };
    DepositorInfoComponent.prototype.getCrm03InCrm04 = function (crm03) {
        if (this.contactDros.CRM04 == null) {
            return null;
        }
        return this.contactDros.CRM04.filter(function (c) {
            return c.RequestedNo == crm03.RequestedNo;
        });
    };
    DepositorInfoComponent.prototype.getCrm03InCrm05 = function (crm03) {
        if (this.contactDros.CRM05 == null) {
            return null;
        }
        return this.contactDros.CRM05.filter(function (c) {
            return c.RequestedNo == crm03.RequestedNo;
        });
    };
    DepositorInfoComponent.prototype.drawTableStatus = function () {
        var _this = this;
        $("#tbStatus tbody").empty();
        try {
            $('#tbStatus').DataTable().clear().destroy();
        }
        catch (e) {
        }
        try {
            //console.log(this.contactDros);
            if (this.contactDros != null && this.contactDros.CRM03 != null) {
                var index_1 = -1;
                //let arr1 = this.contactDros.CRM03.map((obj: any) => { return { ...obj, date: new Date(obj.ModifyDate) }; });
                var arr1 = this.contactDros.CRM03;
                arr1.sort(function (firstObject, secondObject) { return (secondObject.RequestTypeCode - firstObject.RequestTypeCode
                    || new Date(secondObject.ModifyDate.substring(0, 19)).getTime() - new Date(firstObject.ModifyDate.substring(0, 19)).getTime()); });
                // let sortedDesc = arr1.sort((objA: any, objB: any) => objB.date.getTime() - objA.date.getTime());
                arr1.forEach(function (c) {
                    index_1++;
                    var tr = "";
                    tr += '<tr id="' + index_1 + '">';
                    tr += '<td>' + c.RequestedNo + '</td>';
                    tr += '<td>' + c.RequestType + '</td>';
                    tr += '<td>' + c.StatusDefinition + '</td>';
                    tr += '<td>' + c.ProcessDefinition + '</td>';
                    //tr += '<td>' + c.DisplayMessage + '</td>'
                    tr += '<td>' + _this.util.transformDate(c.ModifyDate, "shortWithTime") + '</td>';
                    tr += '</tr>';
                    $("#tbStatus tbody").append(tr);
                });
            }
        }
        catch (e) {
            console.log('draw table status error');
        }
        var thisTs = this;
        $("#tbStatus tbody tr").on("click", function () {
            thisTs.crm03 = {};
            thisTs.crm04 = {};
            thisTs.crm05 = {};
            thisTs.status = thisTs.contactDros.CRM03[parseInt($(this)[0].id)];
            var crm04List = thisTs.getCrm03InCrm04(thisTs.status);
            if (crm04List != null && crm04List.length > 0) {
                thisTs.crm04 = crm04List[0];
                thisTs.crm03 = thisTs.status;
                if (thisTs.crm03.FilePath != null && thisTs.crm03.FilePath != null) {
                    var para = thisTs.crm03.FilePath;
                    var fields = para.split('/');
                    var vfilename = fields[fields.length - 1];
                    thisTs.crm03.FileName = vfilename;
                }
                else {
                    thisTs.crm03.FileName = "ไม่มีเอกสารเพิ่ม";
                }
                $("#crm04Modal").modal("show");
            }
            else {
                var crm05List = thisTs.getCrm03InCrm05(thisTs.status);
                if (crm05List != null && crm05List.length > 0) {
                    thisTs.crm05 = crm05List[0];
                    thisTs.crm03 = thisTs.status;
                    if (thisTs.crm03.FilePath != null && thisTs.crm03.FilePath != null) {
                        var para = thisTs.crm03.FilePath;
                        var fields = para.split('/');
                        var vfilename = fields[fields.length - 1];
                        thisTs.crm03.FileName = vfilename;
                    }
                    else {
                        thisTs.crm03.FileName = "ไม่มีเอกสารเพิ่ม";
                    }
                    $("#crm05Modal").modal("show");
                }
                else {
                    thisTs.crm03 = thisTs.status;
                    if (thisTs.crm03.FilePath != null && thisTs.crm03.FilePath != null) {
                        var para = thisTs.crm03.FilePath;
                        var fields = para.split('/');
                        var vfilename = fields[fields.length - 1];
                        thisTs.crm03.FileName = vfilename;
                    }
                    else {
                        thisTs.crm03.FileName = "ไม่มีเอกสารเพิ่ม";
                    }
                    $("#statusModal").modal("show");
                }
            }
        });
        $("#tbStatus").dataTable({
            retrieve: true,
            'searching': false,
            'paginate': true,
            order: []
        });
    };
    DepositorInfoComponent.prototype.drawTableRefund = function () {
        $("#tbRefund tbody").empty();
        try {
            if (this.contactDros != null && this.contactDros.CRM06 != null) {
                var tr = "";
                tr += '<tr>';
                tr += '<td>' + this.bankName + '</td>';
                tr += '<td>' + this.contactDros.CRM06.IDNo + '</td>';
                tr += '<td class="text-right">' + this.util.numberWithCommas(this.contactDros.CRM06.NetReimbursible) + '</td>';
                tr += '<td></td>';
                tr += '</tr>';
                $("#tbRefund tbody").append(tr);
            }
        }
        catch (e) {
            console.log('draw table refund error');
        }
        var thisTs = this;
        $("#tbRefund tbody tr").on("click", function () {
            $("#financialModal").modal("show");
        });
        $("#tbRefund").dataTable({
            retrieve: true,
            'searching': false,
            'paginate': false
        });
    };
    DepositorInfoComponent.prototype.drawTableDetail = function () {
        $("#tbDetail tbody").empty();
        try {
            if (this.contactDros != null && this.contactDros.CRM06 != null) {
                var tr = "";
                tr += '<tr>';
                tr += '<td>' + this.bankName + '</td>';
                tr += '<td>' + this.contactDros.CRM06.IDNo + '</td>';
                tr += '<td class="text-right">' + this.util.numberWithCommas(this.contactDros.CRM06.NetReimbursible) + '</td>';
                if (this.contactDros.CRM06.ModifyDate != null) {
                    tr += '<td>' + this.util.transformDate(this.contactDros.CRM06.ModifyDate, "short") + '</td>';
                }
                else {
                    tr += '<td>21 ต.ค. 2562</td>';
                }
                tr += '</tr>';
                $("#tbDetail tbody").append(tr);
            }
        }
        catch (e) {
            console.log('draw table detail error');
        }
        var thisTs = this;
        $("#tbDetail tbody tr").on("click", function () {
            thisTs.crm06 = {};
            thisTs.crm06.PhoneNo = thisTs.contactDros.CRM06.PhoneNo;
            thisTs.telephoneOtp = thisTs.contactDros.CRM06.PhoneNo;
            thisTs.verifyOtp = "";
            $("#rebateModal").modal("show");
        });
        $("#tbDetail").dataTable({
            retrieve: true,
            'searching': false,
            'paginate': false
        });
    };
    DepositorInfoComponent.prototype.drawTableAgentBank = function () {
        var _this = this;
        $("#tbAgentBank tbody").empty();
        var index = -1;
        this.agenBankList.forEach(function (c) {
            index++;
            var tr = "";
            tr += '<tr id="' + index + '">';
            tr += '<td>' + (c.dpa_personaltypeidname || c.dpa_companytypeidname || '') + '</td>';
            tr += '<td>' + (c.dpa_idcard || c.dpa_passport || c.dpa_registrationid || '') + '</td>';
            tr += '<td>' + (c.dpa_name || '') + '</td>';
            tr += '<td>' + c.dpa_approvalstatusidname + '</td>';
            tr += '<td>' + _this.util.transformDate(c.dpa_submitdate, "shortWithTime") + '</td>';
            tr += '</tr>';
            $("#tbAgentBank tbody").append(tr);
        });
        var thisTs = this;
        $("#tbAgentBank tbody tr").on("click", function () {
            thisTs.ag = thisTs.agenBankList[parseInt($(this)[0].id)];
            thisTs.ag.dpa_submitdateFormated = thisTs.util.transformDate(thisTs.ag.dpa_submitdate, "shortWithTime");
            if (thisTs.ag.dpa_personaltypeid != null && thisTs.ag.dpa_personaltypeid.length > 0) {
                thisTs.drawTableAgentBankDocList(thisTs.ag.dpa_personaltypeid, null);
            }
            else {
                thisTs.drawTableAgentBankDocList(null, thisTs.ag.dpa_companytypeid);
            }
            $("#agentBankModal").modal("show");
        });
        $("#tbAgentBank").dataTable({
            retrieve: true,
            'searching': false,
            'paginate': false
        });
    };
    DepositorInfoComponent.prototype.drawTableAgentBankDocList = function (personalTypeId, companytypeid) {
        $("#tbDocList tbody").empty();
        var index = 0;
        var docsList;
        if (personalTypeId != null) {
            docsList = this.masterDocNames.filter(function (p) {
                return p.dpa_personaltypeid == personalTypeId;
            });
        }
        else {
            docsList = this.masterDocNamesCompany.filter(function (p) {
                return p.dpa_companytypeid == companytypeid;
            });
        }
        if (docsList != null && docsList.length > 0) {
            docsList[0].dpa_documentgrouplist.forEach(function (n) {
                index++;
                var tr = "";
                tr += '<tr>';
                tr += '<td>' + index.toString() + '</td>';
                tr += '<td>' + n.dpa_name + '</td>';
                tr += '</tr>';
                $("#tbDocList tbody").append(tr);
            });
        }
        $("#tbDocList").dataTable({
            retrieve: true,
            'searching': false,
            'paginate': true
        });
    };
    DepositorInfoComponent.prototype.verify = function () {
        return __awaiter(this, void 0, void 0, function () {
            var reqCheckOtp, reqCheckOtpRes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.verifyOtp.trim().length > 0)) return [3 /*break*/, 2];
                        reqCheckOtp = {
                            OTP: this.verifyOtp.trim(),
                            RefCode: this.otpRef,
                            MobileNo: this.telephoneOtp
                        };
                        return [4 /*yield*/, this.api.postCustom("crm", "VerifyOTP", reqCheckOtp)];
                    case 1:
                        reqCheckOtpRes = _a.sent();
                        if (this.util.isSuccessResponse(reqCheckOtpRes)) {
                            if (reqCheckOtpRes.IsValid) {
                                this.crm06 = this.contactDros.CRM06;
                                //this.crm06.fullname = this.contact.fullname
                                this.crm06.bankname = this.bankName;
                            }
                            else {
                                this.util.WarningDialog("รหัส OTP ที่ท่านกรอกไม่ถูกต้อง");
                            }
                        }
                        else {
                            this.util.WarningDialog("พบข้อผิดพลาดในการยืนยันรหัส OTP กรูณาลองใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่");
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.util.WarningDialog("กรุณากรอกรหัส OTP");
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DepositorInfoComponent.prototype.getDocMasterName = function (id) {
        var name = "";
        this.masterDocNames.forEach(function (m) {
            m.dpa_documentgrouplist.forEach(function (g) {
                for (var i = 0; i < g.dpa_documentlist.length; i++) {
                    if (g.dpa_documentlist[i].dpa_documentid == id) {
                        name = g.dpa_documentlist[i].dpa_name;
                        break;
                    }
                }
            });
        });
        return name;
    };
    DepositorInfoComponent.prototype.requestOtp = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var reqOtp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reqOtp = {
                            MobileNo: this.telephoneOtp,
                        };
                        return [4 /*yield*/, this.api.postCustom("crm", "RequestOTP", reqOtp).then(function (reqOtpRes) { return __awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                var smsContent, sendSms, sendSmsRes;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!this.util.isSuccessResponse(reqOtpRes)) return [3 /*break*/, 2];
                                            smsContent = "รหัสตรวจสอบการยืนยันตัวตนของคุณคือ : ";
                                            smsContent += reqOtpRes.otpNo + " ";
                                            smsContent += "(RefCode : " + reqOtpRes.RefCode;
                                            smsContent += ") (รหัสมีอายุ " + reqOtpRes.expInMinute + " นาที) อย่าเปิดเผยรหัสกับผู้อื่น";
                                            sendSms = {
                                                dpa_description: smsContent,
                                                dpa_phoneno: this.telephoneOtp
                                            };
                                            return [4 /*yield*/, this.api.post("crmservice", "sendSms", sendSms)];
                                        case 1:
                                            sendSmsRes = _a.sent();
                                            if (this.util.isSuccessResponse(sendSmsRes)) {
                                                this.otpRef = reqOtpRes.RefCode;
                                                this.otpTimer = 59;
                                                this.lastReqTime = new Date();
                                                this.requestOtpLbl = "ส่งอีกครั้ง";
                                                this.disableResentOtp = true;
                                                this.countdown();
                                                if (reqOtpRes.expInMinute == undefined || reqOtpRes.expInMinute == null) {
                                                    this.TotalTime = 300;
                                                }
                                                else {
                                                    this.TotalTime = reqOtpRes.expInMinute * 60;
                                                }
                                                this.ElapseTime = 0;
                                                if (this.SubScr != undefined) {
                                                    this.SubScr.unsubscribe();
                                                }
                                                this.SubScr = timer(0, 1000).subscribe(function () { return _this.CountDownOTP(); });
                                            }
                                            else {
                                                this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่");
                                            }
                                            return [3 /*break*/, 3];
                                        case 2:
                                            this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่");
                                            _a.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DepositorInfoComponent.prototype.countdown = function () {
        var _this = this;
        if (this.otpTimer > 0) {
            var dif = new Date().getTime() - this.lastReqTime.getTime();
            var Seconds_from_T1_to_T2 = dif / 1000;
            this.otpTimer = this.totolWaitResend - Math.round(Seconds_from_T1_to_T2);
            setTimeout(function () {
                _this.countdown();
            }, 400);
        }
        else {
            this.disableResentOtp = false;
        }
    };
    DepositorInfoComponent.prototype.CountDownOTP = function () {
        if (this.ElapseTime == 0 && this.TotalTime == 0) {
            this.SubScr.unsubscribe();
            this.OTPCountDown = "";
            return;
        }
        if (this.ElapseTime == this.TotalTime) {
            this.SubScr.unsubscribe();
            this.ElapseTime = 0;
            this.OTPCountDown = "";
            return;
        }
        this.ElapseTime++;
        var RemainingSecs = this.TotalTime - this.ElapseTime;
        var RemainingMins = (RemainingSecs - (RemainingSecs % 60)) / 60;
        RemainingSecs = RemainingSecs % 60;
        this.OTPCountDown = " " + RemainingMins + ":" + (RemainingSecs < 10 ? "0" : "") + RemainingSecs;
    };
    // get03File(vfilename: any)
    // {
    // }
    DepositorInfoComponent.prototype.showPdf = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp, fileName, vfilename, linkSource, win2_1, html_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.crm03.FilePath != null && this.crm03.FilePath != "")) return [3 /*break*/, 2];
                        console.log(this.crm03.FilePath);
                        para = "FilePath=" + this.crm03.FilePath;
                        return [4 /*yield*/, this.api.get("crmservice", "getFileDROS2", para)];
                    case 1:
                        tmp = _a.sent();
                        fileName = this.crm03.FilePath.split('/');
                        vfilename = fileName[fileName.length - 1];
                        linkSource = tmp.File;
                        win2_1 = window.open("", "_blank");
                        html_1 = '';
                        html_1 += '<html><head><title>' + vfilename + '</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>';
                        html_1 += '<body style="margin:0!important">';
                        html_1 += '<embed width="100%" height="100%" src="data:application/pdf;base64,' + encodeURI(linkSource) + '" type="application/pdf" />';
                        html_1 += '</body>';
                        html_1 += '</html>';
                        setTimeout(function () {
                            win2_1.document.write(html_1);
                        }, 0);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return DepositorInfoComponent;
}());
export { DepositorInfoComponent };



// WEBPACK FOOTER //
// ./src/app/depositor-info/depositor-info.component.ts.pre-build-optimizer.js